<template>
  <div id="app">
    <!--hedader-->
    <div class="header" style="box-shadow: rgba(0, 21, 41, 0.08) 0px 1px 4px;">
      <div class="nav">
        <div class="logo">
          <img src="@/assets/img/logo_en.png" />
        </div>
        <div class="linkTo">
          <div class="message" @click="goAnchor('#mail')">
            <!--<el-link href="mailto:lilibo@zxrtb.com" :underline="false">-->
              <i class="el-icon-message"></i>联系我们
            <!--</el-link>-->
          </div>
          <div class="login-btn" @click="routerTo('https://dash.moskenssp.com/login')">登录</div>
        </div>
      </div>
    </div>
    <div class="content" style="margin-top: 70px;">
      <div class="swiper" style="background: #fff;">
        <el-carousel class="nav-el-carousel" :interval="5000" arrow="never">
          <el-carousel-item v-for="item in banner" :key="item.index" :style="{backgroundImage:'url('+require('@/assets/img/banner/banner'+(item.index+1)+'.png')+')'}">
            <div class="swiper-content">
              <div class="swiper-text" :style="{textAlign:(item.index=='2'?'center':'left')}">
                <template v-for="titleItem in item.title">
                  <div class="swiper-title">
                    {{titleItem}}
                  </div>
                </template>
                <template v-for="descItem in item.desc" v-show="item.desc.length>0">
                  <div class="swiper-desc">{{descItem}}</div>
                </template>
                <!--{{item.desc}}-->
                <div class="swiper-btn" v-if="item.button.show" :style="{'marginTop':(item.button.text=='立即接入'?'24px':'56px')}" @click="routerTo('https://dash.moskenssp.com/login')">
                  <span>{{item.button.text}}</span>
                  <img src="@/assets/img/icon/goto.png" />
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="container-wrapper">
        <div class="container-box">
          <div class="container-title absolute">
            业务优势
          </div>
          <div class="container-content">
            <el-row>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                <div class="container-content-item">
                  <img src="@/assets/img/intro/intro1.png" />
                  <div class="title">高效的接入服务</div>
                  <div class="desc">SDK/API支持</div>
                  <div class="desc">实时在线答疑</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                <div class="container-content-item">
                  <img src="@/assets/img/intro/intro2.png" />
                  <div class="title">多元的广告场景</div>
                  <div class="desc">支持开屏/原生/Banner/插屏/激励视频等</div>
                  <div class="desc">并不断探索新的样式</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                <div class="container-content-item">
                  <img src="@/assets/img/intro/intro3.png" />
                  <div class="title">丰富的中台监控</div>
                  <div class="desc">丰富的变现漏斗监控</div>
                  <div class="desc">保证每份流量的充分利用</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                <div class="container-content-item">
                  <img src="@/assets/img/intro/intro4.png" />
                  <div class="title">严格的素材把控</div>
                  <div class="desc">素材审核服务</div>
                  <div class="desc">保证开发者的用户体验</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                <div class="container-content-item">
                  <img src="@/assets/img/intro/intro5.png" />
                  <div class="title">灵活的ADX</div>
                  <div class="desc">Bidding/Waterfall配置充分利用每份流量</div>
                  <div class="desc">对接丰富的DSP资源，保持高水平的填充</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                <div class="container-content-item">
                  <img src="@/assets/img/intro/intro6.png" />
                  <div class="title">自有的投放系统</div>
                  <div class="desc">提供罗卡投放系统</div>
                  <div class="desc">完成您自有客户的投放计划</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="container-wrapper" style="background: linear-gradient(180deg, rgba(245,248,250,0) 0%, #F5F8FA 100%);">
        <div class="container-box">
          <div class="container-title adv">
            广告场景
          </div>
          <div class="container-content tabs" style="display: flex;justify-content: center;padding: 0px !important;">
            <!--hover-->
            <el-tabs tab-position="left" style="height: 200px;" ref="tab">
              <el-tab-pane>
                <span class="tab-item kaiping" id="kaiping" slot="label">
                  <div class="background"></div>
                  <div class="label">开屏广告</div>
                </span>
                <div class="tab-content">
                  <div class="img-box">
                    <div class="img">
                      <!--<img src="@/assets/img/posbannerblack/kaiping1.png" />-->
                      <el-carousel :interval="2500" arrow="never">
                        <el-carousel-item v-for="item in kaipingbanner" :key="item.index">
                          <img :src="require('@/assets/img/posbannerblack/kaiping'+(item.index+1)+'.png')" />
                        </el-carousel-item>
                      </el-carousel>
                    </div>
                  </div>
                  <div class="tab-content-box">
                    <div class="title">
                      开屏广告
                    </div>
                    <div class="desc">
                      APP启动时展示，是APP的第一入口
                    </div>
                    <div class="tab-content-item">
                      <div class="title">特点</div>
                      <div class="box bid-box">
                        <div class="bid-item">
                          <img src="@/assets/img/tab/content/biditem1.png" />
                          <div class="text">强曝光</div>
                        </div>
                        <div class="bid-item">
                          <img src="@/assets/img/tab/content/biditem2.png" />
                          <div class="text">点击率高</div>
                        </div>
                        <div class="bid-item">
                          <img src="@/assets/img/tab/content/biditem3.png" />
                          <div class="text">视觉冲击力强</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持平台</div>
                      <div class="box plat-box">
                        <div class="plat-item">
                          <img src="@/assets/img/tab/content/apple.png" />
                          <div class="text">iOS</div>
                        </div>
                        <div class="plat-item">
                          <img src="@/assets/img/tab/content/android.png" />
                          <div class="text">Android</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">尺寸（宽*高）</div>
                      <div class="box size-box" style="justify-content: space-between;">
                        <div class="size-item">
                          <div class="text">640*960</div>
                        </div>
                        <div class="size-item">
                          <div class="text">720*1280</div>
                        </div>
                        <div class="size-item">
                          <div class="text">720*1560</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持渲染方式</div>
                      <div class="box render-box">
                        <div class="render-item">
                          <div class="text">模板渲染</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持广告类型</div>
                      <div class="box type-box">
                        <div class="type-item">
                          <div class="text">图片</div>
                        </div>
                        <div class="type-item">
                          <div class="text">视频</div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane>
                <span class="tab-item hengfu" id="hengfu" slot="label">
                  <div class="background"></div>
                  <div class="label">横幅广告</div>
                </span>
                <div class="tab-content">
                  <div class="img-box">
                    <div class="img">
                      <img src="@/assets/img/posbannerblack/hengfu.png" />
                    </div>
                  </div>
                  <div class="tab-content-box">
                    <div class="title">
                      横幅广告
                    </div>
                    <div class="desc">
                      停留时间长的页面，在该页面顶/中/底部悬浮且可关闭的边栏广告
                    </div>
                    <div class="tab-content-item">
                      <div class="title">特点</div>
                      <div class="box bid-box">
                        <div class="bid-item">
                          <img src="@/assets/img/tab/content/biditem1.png" />
                          <div class="text">强曝光</div>
                        </div>
                        <div class="bid-item">
                          <img src="@/assets/img/tab/content/biditem4.png" />
                          <div class="text">用户干扰系数低</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持平台</div>
                      <div class="box plat-box">
                        <div class="plat-item">
                          <img src="@/assets/img/tab/content/apple.png" />
                          <div class="text">iOS</div>
                        </div>
                        <div class="plat-item">
                          <img src="@/assets/img/tab/content/android.png" />
                          <div class="text">Android</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">尺寸（宽*高）</div>
                      <div class="box size-box">
                        <div class="size-item">
                          <div class="text">640*100</div>
                        </div>
                        <div class="size-item">
                          <div class="text">1280*720</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持渲染方式</div>
                      <div class="box render-box">
                        <div class="render-item">
                          <div class="text">模板渲染</div>
                        </div>
                        <div class="render-item">
                          <div class="text">开发者自渲染</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持广告类型</div>
                      <div class="box type-box">
                        <div class="type-item">
                          <div class="text">图文</div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane>
                <span class="tab-item xinxiliu" id="xinxiliu" slot="label">
                  <div class="background"></div>
                  <div class="label">信息流广告</div>
                </span>
                <div class="tab-content">
                  <div class="img-box">
                    <div class="img">
                      <img src="@/assets/img/posbannerblack/xinxiliu.png" />
                    </div>
                  </div>
                  <div class="tab-content-box">
                    <div class="title">
                      信息流广告
                    </div>
                    <div class="desc">
                      广告与App内容高度自然融合的信息流
                    </div>
                    <div class="tab-content-item">
                      <div class="title">特点</div>
                      <div class="box bid-box">
                        <div class="bid-item">
                          <img src="@/assets/img/tab/content/biditem4.png" />
                          <div class="text">用户干扰系数低</div>
                        </div>
                        <div class="bid-item">
                          <img src="@/assets/img/tab/content/biditem5.png" />
                          <div class="text">转化效果好</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持平台</div>
                      <div class="box plat-box">
                        <div class="plat-item">
                          <img src="@/assets/img/tab/content/apple.png" />
                          <div class="text">iOS</div>
                        </div>
                        <div class="plat-item">
                          <img src="@/assets/img/tab/content/android.png" />
                          <div class="text">Android</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">尺寸（宽*高）</div>
                      <div class="box size-box">
                        <div class="size-item">
                          <div class="text">9:16</div>
                        </div>
                        <div class="size-item">
                          <div class="text">1280*720</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持渲染方式</div>
                      <div class="box render-box">
                        <div class="render-item">
                          <div class="text">模板渲染</div>
                        </div>
                        <div class="render-item">
                          <div class="text">开发者自渲染</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持广告类型</div>
                      <div class="box type-box">
                        <div class="type-item">
                          <div class="text">图文</div>
                        </div>
                        <div class="type-item">
                          <div class="text">视频</div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane>
                <span class="tab-item chaping" id="chaping" slot="label">
                  <div class="background"></div>
                  <div class="label">插屏广告</div>
                </span>
                <div class="tab-content">
                  <div class="img-box">
                    <div class="img">
                      <img src="@/assets/img/posbannerblack/chaping1.png" />
                    </div>
                  </div>
                  <div class="tab-content-box">
                    <div class="title">
                      插屏广告
                    </div>
                    <div class="desc">
                      在切换界面、关卡结束、暂停时弹出，拥有强信息表现力
                    </div>
                    <div class="tab-content-item">
                      <div class="title">特点</div>
                      <div class="box bid-box">
                        <div class="bid-item">
                          <img src="@/assets/img/tab/content/biditem6.png" />
                          <div class="text">交互场景丰富</div>
                        </div>
                        <div class="bid-item">
                          <img src="@/assets/img/tab/content/biditem7.png" />
                          <div class="text">预算能力充足</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持平台</div>
                      <div class="box plat-box">
                        <div class="plat-item">
                          <img src="@/assets/img/tab/content/apple.png" />
                          <div class="text">iOS</div>
                        </div>
                        <div class="plat-item">
                          <img src="@/assets/img/tab/content/android.png" />
                          <div class="text">Android</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">尺寸（宽*高）</div>
                      <div class="box size-box">
                        <div class="size-item" style="width: 232px;">
                          <div class="text">960*640 或 640*960</div>
                        </div>
                        <div class="size-item" style="width: 232px;">
                          <div class="text">1280*720 或 720*1280</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持渲染方式</div>
                      <div class="box render-box">
                        <div class="render-item">
                          <div class="text">模板渲染</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持广告类型</div>
                      <div class="box type-box">
                        <div class="type-item">
                          <div class="text">图片</div>
                        </div>
                        <div class="type-item">
                          <div class="text">视频</div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane>
                <span class="tab-item jilishipin" id="jilishipin" slot="label">
                  <div class="background"></div>
                  <div class="label">激励视频</div>
                </span>
                <div class="tab-content">
                  <div class="img-box">
                    <div class="img">
                      <img src="@/assets/img/posbannerblack/jilishipin.png" />
                    </div>
                  </div>
                  <div class="tab-content-box">
                    <div class="title">
                      激励视频
                    </div>
                    <div class="desc">
                      完整观看视频广告以免费获得奖励，常用于游戏场景
                    </div>
                    <div class="tab-content-item">
                      <div class="title">特点</div>
                      <div class="box bid-box">
                        <div class="bid-item jilishipin">
                          <img src="@/assets/img/tab/content/biditem8.png" />
                          <div class="text">无干扰、沉浸式的广告体验</div>
                        </div>
                        <div class="bid-item jilishipin">
                          <img src="@/assets/img/tab/content/biditem9.png" />
                          <div class="text">广告点击率、转化率极具优势</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持平台</div>
                      <div class="box plat-box">
                        <div class="plat-item">
                          <img src="@/assets/img/tab/content/apple.png" />
                          <div class="text">iOS</div>
                        </div>
                        <div class="plat-item">
                          <img src="@/assets/img/tab/content/android.png" />
                          <div class="text">Android</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">尺寸（宽*高）</div>
                      <div class="box size-box" style="justify-content: space-between;">
                        <div class="size-item" style="width: 232px;">
                          <div class="text">960*640 或 640*960</div>
                        </div>
                        <div class="size-item" style="width: 232px;">
                          <div class="text">1280*720 或 720*1280</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持渲染方式</div>
                      <div class="box render-box">
                        <div class="render-item">
                          <div class="text">自渲染</div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content-item">
                      <div class="title">支持广告类型</div>
                      <div class="box type-box">
                        <div class="type-item">
                          <div class="text">图片</div>
                        </div>
                        <div class="type-item">
                          <div class="text">视频</div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <div class="container-wrapper form" style="background: #F5F8FA;" id="mail">
        <div class="container-box">
          <div class="container-title">
            期待您的加入
          </div>
          <div class="container-content el-form-content">
            <el-form ref="query" :model="form" :rules="queryRules">
              <el-form-item label="公司主体名称" prop="company">
                <el-input v-model="form.company" placeholder="请填写公司名称" :autosize="{ minRows: 2}" style="width:600px" />
              </el-form-item>
              <div class="item-flex" style="display: flex;">
                <el-form-item class="name" label="联系人姓名" prop="name" style="width: 236px;margin-right: 24px;">
                  <el-input v-model="form.name" placeholder="请填写姓名" :autosize="{ minRows: 2}" />
                </el-form-item>
                <el-form-item class="phone" label="联系电话" prop="phone" style="width: 380px;">
                  <el-input v-model="form.phone" placeholder="请填写电话" :autosize="{ minRows: 2}" />
                </el-form-item>
              </div>
              <el-form-item label="邮箱地址" prop="mail">
                <el-input v-model="form.mail" placeholder="请填写邮箱地址" style="width:600px" />
              </el-form-item>
              <el-form-item label="主营APP名称" prop="appName">
                <el-input v-model="form.appName" placeholder="请填写主营APP名称" style="width:600px" />
              </el-form-item>
              <el-form-item label="咨询内容（选填）" prop="intro">
                <el-input v-model="form.intro" type="textarea" placeholder="请填写您的咨询内容" :autosize="{ minRows: 5}" maxlength="100" show-word-limit style="width:600px" />
              </el-form-item>
              <el-form-item class="intro" prop="hasRead">
                <span slot="label">
                  我已同意并阅读<span class="ruterTo" @click="routerTo('https://vq3x2mi4p9.feishu.cn/docx/HYPFdPkmXoLeSJxzNCGcOPXYnBd')">《隐私协议》</span>
                </span>
                <el-checkbox-group v-model="form.hasRead" @change="groupChange">
                  <el-checkbox label="哈哈哈" name="hasRead"></el-checkbox>
                </el-checkbox-group>
                <div class="el-form-item__error" v-if="hasReadError" style="font-size: 14px;white-space: nowrap;font-weight: 400;color: #ff2020">请同意并阅读《隐私协议》</div>
              </el-form-item>
            </el-form>
          </div>
          <div class="submit-item">
            <div class="submit-btn" @click="submitForm('form')">提交</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="link-left">
        <div class="link-logo">
          <img src="@/assets/img/footerlogo_en.png" />
        </div>
        <div class="lin-box">
          <div class="link-detail" @click="routerTo('https://vq3x2mi4p9.feishu.cn/docx/HYPFdPkmXoLeSJxzNCGcOPXYnBd')">隐私协议</div>
          <div class="link-detail" @click="routerTo('https://vq3x2mi4p9.feishu.cn/docx/A1GpdObMToK1w4xA3kOcQ0eDnNc')">用户服务协议</div>
        </div>
        <div class="link-item">
          <div class="link-item-text">Copyright © 2023-现在zxrtb.cn版权所有</div>
          <div class="link-item-text">北京数优之行科技股份有限公司</div>
          <div class="link-item-text routerTo" @click="routerTo('http://beian.miit.gov.cn/')">京ICP备2022018691号-1</div>
        </div>
      </div>
      <div class="link-right">
        <div class="title">咨询或关注我们</div>
        <div class="other">
          <div class="other-item" style="cursor: pointer;">
            <el-popover placement="bottom" trigger="hover">
              <div>genwenjing@zxrtb.com</div>
              <div slot="reference">
                <div class="img">
                  <img src="@/assets/img/footer/money.png" />
                </div>
                <div class="text">流量变现</div>
              </div>
            </el-popover>
          </div>
          <div class="other-item" style="cursor: pointer;">
            <el-popover placement="bottom" trigger="hover">
              <div>lianghongyan@zxrtb.com</div>
              <div slot="reference">
                <div class="img">
                  <img src="@/assets/img/footer/pos.png" />
                </div>
                <div class="text">广告投放</div>
              </div>
            </el-popover>
          </div>
          <div class="other-item" style="cursor: pointer;">
            <el-popover placement="bottom" trigger="hover">
              <div class="code">
                <img src="@/assets/img/code.jpeg" />
              </div>
              <div slot="reference">
                <div class="img">
                  <img src="@/assets/img/footer/wechat.png" />
                </div>
                <div class="text">关注我们</div>
              </div>
            </el-popover>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  console.log(axios)
  export default {
    data() {
      const validEmailCheck = (rule, value, callback) => {
        if(value != '') {
          if(!(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value))) {
            callback(new Error('请输入有效的邮箱地址'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      const validMobileCheck = (rule, value, callback) => {
        if(value != '') {
          if(!((/^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/.test(value))||(/^((\d{3,4}\-)|)\d{7,8}(|([-\u8f6c]{1}\d{1,5}))$/.test(value)))) {
            callback(new Error('请输入有效的电话'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      return {
        kaipingbanner: [{
          'index': 0
        }, {
          'index': 1
        }],
        banner: [{
            'index': 0,
            'button': {
              'show': true,
              'text': '立即变现'
            },
            'title': ['Mosken流量营销服务平台'],
            'desc': ['Mosken流量营销服务平台通过多元产品形态、强大的技术能力及贴心的服务，为开发者提供一站式的商业化变现方案，为需求方提供优质丰富的高质流量。']
          },
          {
            'index': 1,
            'button': {
              'show': true,
              'text': '立即接入'
            },
            'title': ['Mosken 移动广告SDK'],
            'desc': ['公正、透明、高效的移动广告变现收益提升工具', '支持市场主流ADN快速聚合接入，最大化广告收益', '支持iOS+Android平台']
          },
          {
            'index': 2,
            'button': {
              'show': false
            },
            'title': ['Mosken 移动广告SDK', '通过中国信通院安全测评'],
            'desc': []
          }
        ],
        hasReadError: false,
        form: {
          company: '',
          name: '',
          phone: '',
          mail: '',
          appName: '',
          intro: '',
          hasRead: false
        },
        queryRules: {
          company: [{
            required: true,
            trigger: ['change', 'blur'],
            message: '请填写公司名称'
          }, ],
          name: [{
            required: true,
            trigger: ['change', 'blur'],
            message: '请填写内容'
          }, ],
          phone: [{
            required: true,
            // trigger: ['change', 'blur'],
            message: '请填写正确的电话'
          }, {
              validator: validMobileCheck,
              message: '请输入有效的电话'
          }],
          mail: [{
              required: true,
              //trigger: ['change', 'blur'],
              message: '请填写邮箱地址'
            },
            {
              validator: validEmailCheck,
              message: '请输入有效的邮箱地址'
            }
          ],
          appName: [{
            required: true,
            //trigger: ['change', 'blur'],
            message: '请填写主营APP名称'
          }],
        }
      }
    },
    mounted() {
      var that = this
      this.$nextTick(() => {
        console.log(this.$refs.tab)
        this.$refs.tab.$refs.nav.$nextTick(() => { // 此时tab的nav才渲染dom 否则拿不到el-tabs__item
          var target = document.getElementsByClassName('el-tabs__item')
          for(let i = 0; i < target.length; i++) {
            target[i].addEventListener('mouseover', () => {
              this.$refs.tab.handleTabClick(1, String(i))
            })
          }
        })
      })
      $(document).on('scroll', function() {
        if($(document).scrollTop() > $('.swiper').height()) {
          $('.header').css({
            'background': 'rgba(255,255,255,1)',
            'box-shadow': '0 1px 4px rgba(0,21,41,.08)'
          })
        } else {
          $('.header').css({
            'background': 'rgba(255,255,255,0.1)',
            'box-shadow': 'none'
          })
        }
      })
    },
    methods: {
      groupChange(val) {
        if(!val) {
          this.hasReadError = true
        } else {
          this.hasReadError = false
        }
      },
      submitForm() {
        var that = this
        this.$refs.query.validate((valid) => {
          if(!(that.form.hasRead)) {
            that.hasReadError = true
          } else {
            that.hasReadError = false
          }
          if(valid && (that.hasReadError === false)) {
            axios.post('https://api-omp.zxrtb.com/lead/add', {
              companyName: that.form.company,
              contactName: that.form.name,
              phonenum: that.form.phone,
              mail: that.form.mail,
              appName: that.form.appName,
              content: that.form.intro
            }).then(function(response) {
              if(response.data.errcode == 0) {
                that.$message({
                  message: '您的信息已提交',
                  type: 'success'
                });
                that.hasReadError = false
                that.form.company = ''
                that.form.name = ''
                that.form.phone = ''
                that.form.mail = ''
                that.form.appName = ''
                that.form.intro = ''
                that.$refs.query.resetFields()
              } else {
                that.$message.error(response.data.msg);
              }
            }).catch(function(error) {
              that.$refs.query.resetFields()
            });
          } else {
            return false;
          }
        });
      },
      routerTo(targetHref) {
        if(targetHref) {
          window.open(targetHref)
        }
      },
      //锚点
      goAnchor(anchorName){
        document.querySelector(anchorName).scrollIntoView({
          behavior: "smooth"
        });
      },
      startHacking() {
        this.$notify({
          title: 'It works!',
          type: 'success',
          message: 'We\'ve laid the ground work for you. It\'s time for you to build something epic!',
          duration: 5000
        })
      }
    }
  }
</script>

<style lang="scss">
  #app {
    font-family: Helvetica, sans-serif;
    text-align: center;
  }
  
  body {
    margin: 0px;
    padding: 0px;
    height: 100%;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  }
  
  .code {
    width: 146px;
    height: 146px;
    img {
      width: 146px;
      height: 146px;
    }
  }
  
  .routerTo:hover {
    color: #5DB64C;
    cursor: pointer;
  }
  
  .el-icon-message {
    font-size: 18px;
    font-weight: 500;
    margin-right: 8px;
  }
  
  .el-icon-message:hover {
    color: #5DB64C;
    cursor: pointer;
  }
  
  .el-form-content {
    display: flex;
    justify-content: center;
  }
  
  .el-form {
    .el-input,
    .el-textarea {
      width: 640px !important;
    }
    .el-form-item {
      margin-bottom: 30px;
    }
    .el-form-item__label {
      height: 26px;
      font-size: 18px;
      font-weight: 400;
      color: #666666;
      line-height: 26px;
      margin-bottom: 16px;
    }
    .item-flex .el-form-item.name .el-input {
      width: 236px !important;
    }
    .item-flex .el-form-item.phone .el-input {
      width: 380px !important;
    }
  }
  
  .el-checkbox__input {
    border-radius: 20px !important;
  }
  
  .el-checkbox__label {
    display: none;
  }
  
  .el-checkbox__inner {
    border: 1px solid #5DB64C !important;
    height: 24px;
    width: 24px;
    border-radius: 20px;
  }
  
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    transform: rotate(45deg) scale(2) translateX(3px);
  }
  
  .el-checkbox:focus:not(.is-focus):not(:active):not(.is-disabled) .el-checkbox__inner {
    box-shadow: 0 0 2px 2px #5DB64C !important;
  }
  
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #5DB64C;
  }
  
  .el-textarea__inner,
  .el-input__inner {
    padding: 24px;
    border: 1px solid #5DB64C !important;
    border-radius: 16px;
    height: 64px;
    font-size: 18px;
    font-weight: 400;
    line-height: 26px;
    color: #333333;
  }
  
  .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    display: none;
  }
  
  .el-form-item.is-error {
    .el-checkbox__inner,
    .el-textarea__inner,
    .el-input__inner {
      border: 1px solid #FF2020 !important;
    }
    .el-form-item__error {
      margin-left: 24px;
      height: 22px;
      font-size: 14px;
      font-weight: 400;
      color: #FF2020;
      line-height: 22px;
      white-space: nowrap !important;
    }
  }
  
  .intro {
    margin-bottom: 0px !important;
    position: relative;
    top: -14px;
    display: flex;
    align-items: center;
    .el-form-item__label {
      margin-left: 36px;
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
    }
    .el-form-item__content {
      position: absolute;
      left: 0px;
      top: -10px;
    }
  }
  
  .ruterTo {
    color: #5DB64C;
    font-weight: 600;
    cursor: pointer;
  }
  
  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    display: block;
    background: rgba(255, 255, 255, 0.1);
    /*background: #fff;*/
    backdrop-filter: blur(40px);
  }
  
  .nav {
    margin: 0 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 74px;
    max-width: 1520px;
    .logo {
      img {
        width: 116px;
        height: 47px;
      }
    }
    .linkTo {
      height: 80px;
      display: flex;
      align-items: center;
      .message {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
        .el-link--inner {
          display: flex;
          align-items: center;
        }
        .el-link--inner:hover {
          color: #5DAF34;
        }
        img {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }
      }
      .login-btn {
        margin-left: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        height: 48px;
        border-radius: 28px;
        border: 1px solid rgba(102, 102, 102, 0.5);
      }
    }
    .message:hover {
      cursor: pointer;
      color: #5DAF34;
    }
    .login-btn:hover {
      cursor: pointer;
      color: #5DAF34;
      border-color: #5DAF34;
    }
  }
  
  .swiper {
    height: 480px;
    .swiper-content {
      padding-left: 200px;
      padding-right: 200px;
      margin-top: 120px;
      .swiper-btn {
        margin-top: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 200px;
        height: 64px;
        background: linear-gradient(225deg, #75E660 0%, #6CDD86 33%, #56C9C1 66%, #37B2ED 90%, #20A7FF 100%);
        border-radius: 32px;
        cursor: pointer;
        span {
          height: 28px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 28px;
          letter-spacing: 1px;
        }
        img {
          width: 32px;
          height: 32px;
        }
      }
      .swiper-text {
        text-align: left;
        .swiper-title {
          margin-bottom: 24px;
          height: 56px;
          font-size: 48px;
          font-weight: 600;
          color: #333333;
          line-height: 56px;
          letter-spacing: 4px;
        }
        .swiper-desc {
          width: 619px;
          font-size: 16px;
          font-weight: 400;
          color: #666666;
          line-height: 32px;
          letter-spacing: 1px;
        }
      }
    }
    .nav-el-carousel.el-carousel--horizontal {
      overflow: hidden;
      height: 480px;
      .el-carousel__container {
        .el-carousel__item {
          width: 100%;
          display: inline-block;
          overflow: hidden;
          z-index: 0;
          height: 480px;
          background-repeat: no-repeat;
          background-position: 50%;
          background-size: cover;
        }
      }
      .el-carousel__indicators {
        bottom: 60px;
      }
      .el-carousel__indicator--horizontal {
        padding: 12px 6px;
      }
      .el-carousel__button {
        width: 12px;
        height: 4px;
        background: #5DB64C;
        border-radius: 2px;
        opacity: 0.4;
      }
      .el-carousel__indicator.is-active button {
        background: #5DB64C;
        width: 40px;
        opacity: 1;
      }
    }
  }
  /*内容部分*/
  
  .img .el-carousel.el-carousel--horizontal {
    /*height: 730px;
    width: 340px;*/
    width: 520px;
    height: 860px;
    .el-carousel__container {
      /*height: 730px;*/
      height: 860px;
    }
    .el-carousel__indicators {
      bottom: 10px;
    }
    .el-carousel__indicator--horizontal {
      button {
        width: 12px;
        height: 4px;
        background: #5DB64C;
        opacity: 0.4;
        border-radius: 2px;
      }
    }
    .el-carousel__indicator--horizontal.is-active {
      button {
        width: 40px;
        background: #5DB64C;
        opacity: 1;
        border-radius: 2px;
      }
    }
  }
  
  .container-content.form {
    .container-title {
      padding-top: 80px;
    }
  }
  
  .container-wrapper {
    position: relative;
    .container-title {
      padding-top: 50px;
      margin-bottom: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;
      font-size: 32px;
      font-weight: 600;
      color: #333333;
      line-height: 36px;
      letter-spacing: 1px;
    }
    .container-title.absolute {
      position: relative;
      display: flex;
      justify-content: center;
      width: 100%;
      top: -18px;
    }
    .container-title.adv {
      margin-top: 56px;
      margin-bottom: 72px;
    }
    .container-content.tabs {
      padding: 0px 0px 0px 190px !important;
    }
    .container-content {
      padding: 0px 200px;
      /*业务优势*/
      .el-row {
        display: flex;
        flex-wrap: wrap;
      }
      .container-content-item {
        padding: 16px 0px 42px 0px;
        text-align: center;
        img {
          height: 96px;
          width: 96px;
        }
        .title {
          margin-top: 12px;
          margin-bottom: 6px;
          height: 32px;
          font-size: 20px;
          font-weight: 600;
          color: #333333;
          line-height: 32px;
          text-align: center;
        }
        .desc {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 22px;
          letter-spacing: 1px;
          text-align: center;
        }
      }
      /*广告场景*/
      .el-tabs--left .el-tabs__nav-wrap.is-left::after,
      .el-tabs--left .el-tabs__nav-wrap.is-right::after,
      .el-tabs--right .el-tabs__nav-wrap.is-left::after,
      .el-tabs--right .el-tabs__nav-wrap.is-right::after {
        width: 0px;
      }
      .el-tabs--left .el-tabs__active-bar.is-left,
      .el-tabs--left .el-tabs__active-bar.is-right,
      .el-tabs--right .el-tabs__active-bar.is-left,
      .el-tabs--right .el-tabs__active-bar.is-right {
        width: 0px;
      }
      .el-tabs {
        height: 795px !important;
        .el-tabs__active-bar {
          border: 0px;
        }
        .el-tabs__nav {
          .el-tabs__item {
            padding: 40px 58px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 280px;
            height: 118px;
            margin-bottom: 24px;
            border-radius: 16px;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 26px;
            .tab-item {
              display: flex;
              align-items: center;
              .background {
                position: relative;
                left: -10px;
                width: 80px;
                height: 80px;
                background-repeat: no-repeat;
                background-position: 50%;
                background-size: cover;
              }
            }
            .kaiping .background {
              background-image: url("https://lp.zxrtb.com/img/tab/kaiping.png");
            }
            .hengfu .background {
              background-image: url("https://lp.zxrtb.com/img/tab/hengfu.png");
            }
            .xinxiliu .background {
              background-image: url("https://lp.zxrtb.com/img/tab/xinxiliu.png");
              position: relative;
              left: 0px;
            }
            .chaping .background {
              background-image: url("https://lp.zxrtb.com/img/tab/chaping.png");
            }
            .jilishipin .background {
              background-image: url("https://lp.zxrtb.com/img/tab/jilishipin.png");
            }
          }
          .el-tabs__item.is-active {
            background: rgba(93, 182, 76, 0.08);
            font-size: 24px;
            font-weight: 600;
            color: #5DB64C;
            .background {
              position: relative;
              left: 0px;
            }
            .kaiping .background {
              background-image: url("https://lp.zxrtb.com/img/tab/kaipingactive.png");
            }
            .hengfu .background {
              background-image: url("https://lp.zxrtb.com/img/tab/hengfuactive.png");
            }
            .xinxiliu .background {
              background-image: url("https://lp.zxrtb.com/img/tab/xinxiliuactive.png");
              position: relative;
              left: 14px;
            }
            .xinxiliu .label {
              position: relative;
              left: 14px;
            }
            .chaping .background {
              background-image: url("https://lp.zxrtb.com/img/tab/chapingactive.png");
            }
            .jilishipin .background {
              background-image: url("https://lp.zxrtb.com/img/tab/jilishipinactive.png");
            }
          }
        }
        .el-tabs__content {
          width: auto;
          .tab-content {
            display: flex;
            justify-content: flex-start;
            width: auto;
            padding-top: 20px;
            .img-box {
              position: relative;
              top: -100px;
              margin-left: 50px;
              /*margin-left: 150px;*/
              .img {
                img {
                  width: 520px;
                  height: auto;
                  /*width: 340px;
                  height: 676px;*/
                }
              }
            }
            .tab-content-box {
              margin-left: 88px;
              text-align: left;
              .title {
                margin-bottom: 16px;
                height: 32px;
                font-size: 24px;
                font-weight: 600;
                color: #333333;
                line-height: 32px;
              }
              .desc {
                width: 480px;
                height: 52px;
                font-size: 18px;
                font-weight: 400;
                color: #666666;
                line-height: 25px;
              }
              .tab-content-item {
                margin-top: 24px;
                .title {
                  height: 22px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #666666;
                  line-height: 22px;
                }
                .box {
                  width: 480px;
                  display: flex;
                  justify-content: flex-start;
                }
                .bid-box {
                  display: flex;
                  align-items: center;
                  justify-content: space-evenly;
                  width: 480px;
                  height: 136px;
                  background: rgba(0, 0, 0, 0.02);
                  border-radius: 24px;
                }
                .bid-item.jilishipin {
                  .text {
                    font-size: 14px;
                    white-space: nowrap;
                  }
                }
                .bid-item {
                  width: 148px;
                  text-align: center;
                  img {
                    height: 64px;
                    width: 64px;
                    margin-bottom: 8px;
                  }
                  .text {
                    display: flex;
                    justify-content: center;
                    height: 26px;
                    font-size: 18px;
                    font-weight: 400;
                    color: #666666;
                    line-height: 26px;
                  }
                }
                .plat-item,
                .size-item,
                .render-item,
                .type-item {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 148px;
                  height: 48px;
                  background: rgba(0, 0, 0, 0.02);
                  border-radius: 10px;
                  margin-right: 16px;
                  img {
                    width: 20px;
                    height: 20px;
                    margin-right: 4px;
                  }
                  .text {
                    display: flex;
                    align-items: center;
                    font-size: 18px;
                    font-weight: 400;
                    color: #666666;
                    line-height: 26px;
                  }
                }
                .plat-item:last-child,
                .size-item:last-child,
                .render-item:last-child,
                .type-item:last-child {
                  margin-right: 0px;
                }
              }
            }
          }
        }
      }
    }
  }
  
  .submit-item {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 26px;
    padding-bottom: 80px;
    .submit-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 396px;
      height: 64px;
      background: linear-gradient(225deg, #75E660 0%, #6CDD86 33%, #56C9C1 66%, #37B2ED 90%, #20A7FF 100%) rgba(0, 0, 0, 0.08);
      border-radius: 32px;
      font-size: 20px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 28px;
      letter-spacing: 1px;
      cursor: pointer;
    }
  }
  
  .footer {
    background: #333333;
    padding: 40px 200px;
    display: flex;
    justify-content: space-between;
    .link-left {
      text-align: left;
      img {
        height: 47px;
        width: 116px;
        margin-bottom: 33px;
      }
      .lin-box {
        display: flex;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        line-height: 20px;
        .link-detail:hover {
          color: #5DB64C;
          cursor: pointer;
        }
        .link-detail:first-child {
          margin-right: 24px;
        }
      }
      .link-item {
        margin-top: 17px;
        display: flex;
        .link-item-text {
          margin-right: 24px;
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #AAAAAA;
          line-height: 20px;
        }
        .link-item-text.routerTo:hover {
          color: #5DB64C;
          cursor: pointer;
        }
      }
    }
    .link-right {
      text-align: left;
      .title {
        height: 26px;
        font-size: 18px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.8);
        line-height: 26px;
        letter-spacing: 1px;
        margin-bottom: 24px;
      }
      .other {
        display: flex;
        align-items: center;
        justify-content: center;
        .other-item {
          margin-right: 28px;
          .img {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 56px;
            height: 56px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 30px;
            img {
              width: 24px;
              height: 24px;
            }
          }
          .text {
            margin-top: 4px;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.8);
            line-height: 20px;
          }
        }
      }
    }
  }
  /*自适应*/
  @media only screen and (max-width: 1600px) {
    /*内容*/
    .container-wrapper {
      .container-title {
        font-size: 22px;
      }
      .container-content.tabs {
        padding-right: 0px;
      }
      .container-content {
        /*广告场景*/
        .el-tabs {
          .el-tabs__content {
            .tab-content {
              width: auto;
              padding-top: 0px;
              .img-box {
                margin-left: 24px;
              }
              .tab-content-box {
                margin-left: 24px;
              }
            }
          }
        }
      }
    }
  }
  
  @media only screen and (max-width: 1280px) {
    .nav {
      margin: 0px 130px;
    }
    /*轮播*/
    .swiper {
      height: 340px;
      .swiper-content {
        margin-top: 80px;
        padding-left: 130px;
        padding-right: 130px;
        .swiper-btn {
          width: 133px;
          height: 43px;
          span {
            height: 19px;
            font-size: 13px;
            line-height: 19px;
          }
          img {
            width: 20px;
            height: 20px;
          }
        }
        .swiper-text {
          .swiper-title {
            margin-bottom: 16px;
            font-size: 32px;
            line-height: 56px;
            letter-spacing: 3px;
            line-height: 48px;
          }
          .swiper-desc {
            width: 460px;
            font-size: 12px;
            line-height: 21px;
            letter-spacing: 1px;
          }
        }
      }
    }
    .nav-el-carousel.el-carousel--horizontal {
      height: 340px;
      .el-carousel__container {
        .el-carousel__item {
          height: 340px !important;
        }
      }
      .el-carousel__indicators {
        bottom: 180px !important;
      }
    }
    .img .el-carousel.el-carousel--horizontal {
      overflow: hidden;
      /*height: 500px;
      width: 226px;*/
     height: 571px;
     width: 347px;
      .el-carousel__container {
        /*height: 500px;*/
       height: 571px;
      }
      .el-carousel__indicators {
        bottom: 20px;
      }
      .el-carousel__indicator--horizontal {
        button {
          width: 8px;
          height: 3px;
        }
      }
      .el-carousel__indicator--horizontal.is-active {
        button {
          width: 27px;
          opacity: 1;
        }
      }
    }
    /*内容*/
    .container-content.form {
      .container-title {
        padding-top: 53px;
      }
    }
    .container-wrapper {
      .container-title {
        font-size: 22px;
      }
      .container-title.absolute {
        margin-bottom: 24px;
        top: -18px;
      }
      .container-title.adv {
        margin-top: 38px;
        margin-bottom: 48px;
      }
      .container-content.tabs {
        padding-right: 0px;
        padding-left: 190px;
        height: 500px;
      }
      .container-content {
        padding: 0px 130px;
        /*业务优势*/
        .container-content-item {
          padding: 12px 0px 28px 0px;
          text-align: center;
          img {
            height: 64px;
            width: 64px;
          }
          .title {
            font-size: 16px;
          }
          .desc {
            font-size: 12px;
          }
        }
        /*广告场景*/
        .el-tabs {
          height: 625px !important;
          .el-tabs__nav {
            .el-tabs__item {
              padding: 28px 48px;
              width: 190px;
              height: 75px;
              margin-bottom: 16px;
              border-radius: 12px;
              font-size: 12px;
              line-height: 18px;
              .tab-item {
                .background {
                  width: 53px;
                  height: 53px;
                }
              }
              xinxiliu .background {
                left: 6px;
              }
              .xinxiliu .label {
                position: relative;
                left: 6px;
              }
            }
            .el-tabs__item.is-active {
              font-size: 16px;
              .xinxiliu .background {
                left: 6px;
              }
              .xinxiliu .label {
                position: relative;
                left: 6px;
              }
            }
          }
          .el-tabs__content {
            .tab-content {
              width: auto;
              padding-top: 0px;
              .img-box {
                top:-50px;
                /*margin-left: 97px;*/
                .img {
                  img {
                    width: 347px;
                    height: 571px;
                  }
                }
              }
              .tab-content-box {
                margin-left: 58px;
                .title {
                  height: 21px;
                  font-size: 16px;
                  line-height: 21px;
                }
                .desc {
                  width: 320px;
                  height: auto;
                  font-size: 12px;
                  line-height: 17px;
                }
                .tab-content-item {
                  margin-top: 17px;
                  .title {
                    margin-bottom: 5px;
                    height: 15px;
                    line-height: 15px;
                  }
                  .box {
                    width: 320px;
                  }
                  .bid-box {
                    width: 320px;
                    height: 91px;
                    border-radius: 16px;
                  }
                  .bid-item.jilishipin {
                    .text {
                      position: relative;
                      top: -10px;
                      font-size: 12px;
                      white-space: pre-wrap;
                    }
                  }
                  .bid-item {
                    width: 100px;
                    img {
                      height: 43px;
                      width: 43px;
                      margin-bottom: 5px;
                    }
                    .text {
                      height: 17px;
                      font-size: 12px;
                      line-height: 17px;
                    }
                  }
                  .plat-item,
                  .size-item,
                  .render-item,
                  .type-item {
                    width: 100px;
                    height: 32px;
                    border-radius: 7px;
                    margin-right: 11px;
                    img {
                      width: 13px;
                      height: 13px;
                      margin-right: 3px;
                    }
                    .text {
                      font-size: 12px;
                      line-height: 17px;
                    }
                  }
                  .plat-item:last-child,
                  .size-item:last-child,
                  .render-item:last-child,
                  .type-item:last-child {
                    margin-right: 0px;
                  }
                }
              }
            }
          }
        }
      }
    }
    /*表单提交*/
    .el-form {
      .el-input,
      .el-textarea {
        width: 428px !important;
      }
      .el-form-item {
        margin-bottom: 20px;
        width: 428px;
      }
      .el-form-item__label {
        height: 17px;
        font-size: 12px;
        line-height: 17px;
        margin-bottom: 11px;
      }
      .item-flex .el-form-item.name,
      .item-flex .el-form-item.name .el-input {
        width: 157px !important;
      }
      .item-flex .el-form-item.phone,
      .item-flex .el-form-item.phone .el-input {
        width: 253px !important;
      }
    }
    .el-checkbox__inner {
      height: 16px;
      width: 16px;
      border-radius: 20px;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner::after {
      transform: rotate(45deg) scale(1) translateX(2px);
    }
    .el-textarea__inner,
    .el-input__inner {
      padding: 13px 16px;
      border-radius: 12px;
      height: 43px;
      font-size: 12px;
      line-height: 17px;
      color: #333333;
    }
    .el-form-item.is-error {
      .el-form-item__error {
        margin-left: 16px;
        height: 15px;
        font-size: 12px;
        line-height: 15px;
      }
    }
    .intro {
      top: -11px;
      .el-form-item__label {
        margin-left: 24px;
        height: 15px;
        font-size: 12px;
        line-height: 25px;
      }
      .el-form-item__content {
        position: absolute;
        left: 0px;
        top: -10px;
      }
    }
    .submit-item {
      padding-bottom: 53px;
      .submit-btn {
        width: 264px;
        height: 43px;
        border-radius: 21px;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 1px;
      }
    }
    .footer {
      padding: 40px 130px;
      .link-right {
        .title {
          font-size: 14px;
          margin-bottom: 16px;
        }
      }
    }
  }
  
  @media only screen and (max-width: 1180px) {
    /*内容*/
    .container-wrapper {
      .container-title {
        font-size: 22px;
      }
      .container-content.tabs {
        padding: 0px !important;
        display: flex;
        justify-content: center;
      }
      .container-content {
        /*广告场景*/
        .el-tabs {
          .el-tabs__content {
            .tab-content {
              width: auto;
              padding-top: 0px;
              .img-box {
                margin-left: 24px;
              }
              .tab-content-box {
                margin-left: 24px;
              }
            }
          }
        }
      }
    }
  }
  
  @media only screen and (max-width: 992px) {
    .footer .link-left .link-item {
      display: block;
      .link-item-text {
        margin-top: 4px;
      }
    }
  }
  
  @media only screen and (max-width: 768px) {}
</style>


// WEBPACK FOOTER //
// src/App.vue